(function(root,factory){
  'use strict';
  var api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else if(root&&root.document)api.mount(root);
})(typeof window!=='undefined'?window:null,function(){
  'use strict';
  function matches(line,c){return Number(line.variant_id||line.id)===c.variantId&&line.properties&&line.properties._sv_free_gift===c.key;}
  function decisionKey(c){return 'sv_declined_'+(c.campaignId||c.key);}
  function declined(cart,c){return String((cart.attributes||{})[decisionKey(c)]||'')==='1';}
  function validate(config){
    if(!config||!Array.isArray(config.active)||!Array.isArray(config.retired))throw Error('Invalid promotion configuration');
    var seen={};
    config.active.concat(config.retired).forEach(function(c){
      var identity=c.key+':'+c.variantId;
      if(!c.key||!Number.isSafeInteger(c.variantId)||c.variantId<=0||seen[identity])throw Error('Invalid campaign');
      seen[identity]=true;
    });
    config.active.forEach(function(c){if(!/^[a-z0-9_]+$/.test(c.campaignId||c.key)||(!config.weekly&&(!Number.isSafeInteger(c.thresholdCents)||c.thresholdCents<=0)))throw Error('Invalid active campaign');});
    if(config.weekly){
      if(!Array.isArray(config.weekly.purchaseProductIds)||!Array.isArray(config.weekly.packProductIds))throw Error('Invalid purchase catalog');
      ['both','collagen','organizer'].forEach(function(k){if(!Number.isSafeInteger(config.weekly.bundles[k]))throw Error('Invalid gift bundle');});
    }
    return config;
  }
  function bundleKey(line,config){
    if(!config.weekly)return null;
    return Object.keys(config.weekly.bundles).find(function(k){return Number(line.variant_id||line.id)===config.weekly.bundles[k];})||null;
  }
  function purchaseFacts(cart,config){
    var f={subtotal:0,quantity:0,pack:false};
    (cart.items||[]).forEach(function(line){
      if(bundleKey(line,config)||config.retired.some(function(c){return matches(line,c);}))return;
      if(config.weekly.purchaseProductIds.indexOf(Number(line.product_id))<0)return;
      f.subtotal+=Number(line.original_line_price!=null?line.original_line_price:line.line_price||0);
      f.quantity+=Number(line.quantity||0);
      if(config.weekly.packProductIds.indexOf(Number(line.product_id))>=0)f.pack=true;
    });
    f.collagen=f.quantity>=3||f.pack;f.organizer=f.subtotal>=3000||f.collagen;return f;
  }
  function purchaseSubtotal(cart,config){
    if(config.weekly)return purchaseFacts(cart,config).subtotal;
    return (cart.items||[]).reduce(function(sum,line){
      if(config.active.concat(config.retired).some(function(c){return matches(line,c);}))return sum;
      return sum+Number(line.original_line_price!=null?line.original_line_price:line.line_price||0);
    },0);
  }
  function nextOperation(cart,config){
    var items=cart.items||[];
    var old=items.find(function(l){return config.retired.some(function(c){return matches(l,c);});});
    if(old)return {type:'change',key:old.key,quantity:0};
    if(config.weekly){
      var facts=purchaseFacts(cart,config);
      var wantsM=facts.collagen&&!declined(cart,config.active.find(function(c){return c.key==='colageno_3_productos';}));
      var wantsO=facts.organizer&&!declined(cart,config.active.find(function(c){return c.key==='organizador_rutina_sevens';}));
      var desired=wantsM&&wantsO?'both':wantsM?'collagen':wantsO?'organizer':null;
      var gifts=items.filter(function(l){return bundleKey(l,config);});
      var unwanted=gifts.find(function(l){return bundleKey(l,config)!==desired;});
      if(unwanted)return {type:'change',key:unwanted.key,quantity:0};
      if(gifts.length>1)return {type:'change',key:gifts[1].key,quantity:0};
      if(gifts.length&&gifts[0].quantity!==1)return {type:'change',key:gifts[0].key,quantity:1};
      if(desired&&!gifts.length)return {type:'add',variantId:config.weekly.bundles[desired],key:desired,quantity:1};
      return null;
    }
    var subtotal=purchaseSubtotal(cart,config);
    for(var i=0;i<config.active.length;i++){
      var c=config.active[i],lines=items.filter(function(l){return matches(l,c);});
      if(declined(cart,c)||subtotal<c.thresholdCents){
        if(lines.length)return {type:'change',key:lines[0].key,quantity:0};
      }else{
        if(lines.length>1)return {type:'change',key:lines[1].key,quantity:0};
        if(lines.length&&lines[0].quantity!==1)return {type:'change',key:lines[0].key,quantity:1};
        if(!lines.length)return {type:'add',variantId:c.variantId,key:c.key,quantity:1};
      }
    }
    return null;
  }
  function createController(config,request,lock){
    validate(config);
    var tail=Promise.resolve(),scheduled=null;
    lock=lock||function(fn){return fn();};
    function enqueue(fn){
      var result=tail.catch(function(){}).then(function(){return lock(fn);});
      tail=result.catch(function(){});
      return result;
    }
    async function settle(){
      var changed=false;
      for(var pass=0;pass<25;pass++){
        var cart=await request('cart.js'),op=nextOperation(cart,config);
        if(!op)return {changed:changed,cart:cart};
        if(op.type==='change')await request('cart/change.js',{id:op.key,quantity:op.quantity});
        else await request('cart/add.js',{items:[{id:op.variantId,quantity:1,properties:{_sv_free_gift:op.key}}]});
        changed=true;
      }
      throw Error('Cart did not stabilize');
    }
    function reconcile(){
      if(scheduled)return scheduled;
      scheduled=enqueue(settle);
      var result=scheduled;
      result.then(function(){if(scheduled===result)scheduled=null;},function(){if(scheduled===result)scheduled=null;});
      return result;
    }
    function choose(key,reject){
      var selected=key==='both'&&config.weekly?config.active:config.active.filter(function(c){return c.key===key;});
      if(!selected.length)return Promise.reject(Error('Unknown gift'));
      return enqueue(async function(){
        // Persist the decision before any removal. A failed write leaves the line untouched.
        var attrs={};selected.forEach(function(c){attrs[decisionKey(c)]=reject?'1':'';});
        await request('cart/update.js',{attributes:attrs});
        var result=await settle();result.changed=true;return result;
      });
    }
    return {reconcile:reconcile,decline:function(key){return choose(key,true);},restore:function(key){return choose(key,false);}};
  }
  function mount(win){
    var doc=win.document;
    if(win.__svPromotionsMounted)return;
    var node=doc.getElementById('sv-promotion-config');if(!node)return;
    var config;try{config=validate(JSON.parse(node.textContent));}catch(e){win.console.error(e);return;}
    win.__svPromotionsMounted=true;
    var originalFetch=win.fetch.bind(win),rootPath=(win.Shopify&&win.Shopify.routes&&win.Shopify.routes.root)||'/';
    if(!rootPath.endsWith('/'))rootPath+='/';
    var pending=0,busy=0,checkoutBusy=false,resuming=false,timer=null,retryAfter=0,refreshPending=false;
    var english=doc.documentElement.lang.indexOf('en')===0;
    async function request(route,payload){
      var r=await originalFetch(rootPath+route,{method:payload?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json','Content-Type':'application/json'},body:payload?JSON.stringify(payload):undefined});
      if(!r.ok)throw Error('Cart request failed ('+r.status+')');
      var result=await r.json();if(result.errors)throw Error('Cart update rejected');return result;
    }
    var withLock=win.navigator.locks?function(fn){return win.navigator.locks.request('sevens-promotions-cart',fn);}:null;
    var controller=createController(config,request,withLock);
    function error(e){
      win.console.warn('[Sevens promotions]',e.message);retryAfter=Date.now()+10000;
      var alert=doc.getElementById('sv-promotion-error');
      if(!alert){alert=doc.createElement('div');alert.id='sv-promotion-error';alert.setAttribute('role','alert');alert.setAttribute('tabindex','-1');alert.className='sv-promotion-error';doc.body.appendChild(alert);}
      alert.textContent=e.message==='Gift discount missing'?(english?'Your gift discount has not been applied. Please check your cart before continuing.':'El descuento del regalo aún no se ha aplicado. Revisa el carrito antes de continuar.'):(english?'We could not update your cart. Please try again.':'No hemos podido actualizar tu carrito. Vuelve a intentarlo.');
      alert.focus();
    }
    function clearError(){var el=doc.getElementById('sv-promotion-error');if(el)el.remove();}
    function refresh(){
      // Use the theme's section renderer: keep the open drawer and scroll position.
      if(doc.querySelector('cart-items')){
        refreshPending=true;
        doc.dispatchEvent(new win.CustomEvent('theme:cart:refresh',{bubbles:true}));
      }else win.location.reload();
    }
    function schedule(){
      if(busy||checkoutBusy||Date.now()<retryAfter)return;
      win.clearTimeout(timer);
      timer=win.setTimeout(function(){
        if(pending||busy||checkoutBusy){schedule();return;}
        controller.reconcile().then(function(r){if(r.changed&&!checkoutBusy)refresh();}).catch(error);
      },200);
    }
    function cartWrite(input){
      try{var u=new URL(input&&input.url?input.url:input,win.location.href);return u.origin===win.location.origin&&/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(u.pathname);}catch(e){return false;}
    }
    win.fetch=function(input,init){
      var tracked=cartWrite(input);if(tracked)pending++;
      return originalFetch(input,init).finally(function(){if(tracked){pending--;schedule();}});
    };
    if(win.XMLHttpRequest){
      var open=win.XMLHttpRequest.prototype.open;
      win.XMLHttpRequest.prototype.open=function(method,url){
        if(cartWrite(url)){this.addEventListener('loadstart',function(){pending++;},{once:true});this.addEventListener('loadend',function(){pending=Math.max(0,pending-1);schedule();},{once:true});}
        return open.apply(this,arguments);
      };
    }
    async function waitNetwork(){
      var until=Date.now()+8000;
      while((pending||busy)&&Date.now()<until)await new Promise(function(resolve){win.setTimeout(resolve,40);});
      if(pending||busy)throw Error('Cart update still pending');
    }
    function campaignFor(row){
      if(!row)return null;
      if(config.weekly&&row.getAttribute('data-sv-gift-key')==='both')return {key:'both'};
      if(config.weekly&&row.getAttribute('data-sv-gift-key')==='collagen')return {key:'colageno_3_productos'};
      if(config.weekly&&row.getAttribute('data-sv-gift-key')==='organizer')return {key:'organizador_rutina_sevens'};
      return config.active.find(function(c){return c.key===row.getAttribute('data-sv-gift-key');});
    }
    var choices={};
    function choose(event,key,reject){
      event.preventDefault();event.stopImmediatePropagation();
      if(choices[key])return;
      choices[key]=true;busy++;win.clearTimeout(timer);
      var row=event.target.closest('[data-item]');if(row)row.setAttribute('aria-busy','true');
      // Set busy synchronously, so timers and checkout cannot race the persisted decision.
      (async function(){
        var until=Date.now()+8000;
        while(pending&&Date.now()<until)await new Promise(function(resolve){win.setTimeout(resolve,40);});
        if(pending)throw Error('Cart update still pending');
        await (reject?controller.decline(key):controller.restore(key));
        clearError();refresh();
      })().catch(error).finally(function(){busy--;delete choices[key];if(row)row.removeAttribute('aria-busy');schedule();});
    }
    doc.addEventListener('click',function(event){
      if(!(event.target instanceof win.Element))return;
      var restore=event.target.closest('[data-sv-restore-gift]');
      if(restore){choose(event,restore.getAttribute('data-sv-restore-gift'),false);return;}
      var declineButton=event.target.closest('[data-sv-decline-gift]');
      if(declineButton){choose(event,declineButton.getAttribute('data-sv-decline-gift'),true);return;}
      var row=event.target.closest('[data-sv-gift-key]'),c=campaignFor(row);
      if(!c)return;
      var remove=event.target.closest('[data-item-remove]');
      var minus=event.target.closest('button[name="decrease"]');
      var input=row.querySelector('input[name="updates[]"]');
      if(remove||(minus&&Number(input&&input.value)<=1))choose(event,c.key,true);
    },true);
    doc.addEventListener('change',function(event){
      if(!(event.target instanceof win.Element)||!event.target.matches('input[name="updates[]"]'))return;
      var row=event.target.closest('[data-sv-gift-key]'),c=campaignFor(row);
      if(c&&Number(event.target.value)===0)choose(event,c.key,true);
    },true);
    doc.addEventListener('theme:cart:update',function(event){
      if(!(event.target instanceof win.Element))return;
      var c=campaignFor(event.target.closest('[data-sv-gift-key]'));
      if(c&&event.detail&&Number(event.detail.quantity)===0)choose(event,c.key,true);
    },true);
    async function beforeCheckout(event,resume){
      event.preventDefault();event.stopImmediatePropagation();if(checkoutBusy)return;
      checkoutBusy=true;win.clearTimeout(timer);
      try{
        await waitNetwork();
        await controller.reconcile();
        // A fresh pass follows any in-flight reconciliation started before the last user write.
        var final=await controller.reconcile();
        if(config.weekly&&(final.cart.items||[]).some(function(l){return bundleKey(l,config)&&Number(l.final_line_price)!==0;}))throw Error('Gift discount missing');
        clearError();resuming=true;try{resume();}finally{resuming=false;}
      }catch(e){error(e);}finally{checkoutBusy=false;}
    }
    doc.addEventListener('click',function(event){
      if(resuming||!(event.target instanceof win.Element))return;
      var el=event.target.closest('a[href],button[name="checkout"],input[name="checkout"]');if(!el)return;
      var checkout=el.name==='checkout';
      if(el.tagName==='A'){var url=new URL(el.href,win.location.href);checkout=url.origin===win.location.origin&&/\/checkout\/?$/.test(url.pathname);}
      if(checkout)beforeCheckout(event,function(){el.click();});
    },true);
    doc.addEventListener('submit',function(event){
      if(resuming)return;var button=event.submitter,form=event.target;
      if((button&&button.name==='checkout')||/\/checkout\/?(?:[?#]|$)/.test(form.action||''))beforeCheckout(event,function(){form.requestSubmit(button||undefined);});
    },true);
    doc.addEventListener('theme:cart:change',function(){refreshPending=false;schedule();});
    ['cart:updated','variant:add'].forEach(function(name){doc.addEventListener(name,schedule);});
    win.addEventListener('pageshow',schedule);win.addEventListener('focus',schedule);
    doc.addEventListener('visibilitychange',function(){if(!doc.hidden)schedule();});
    win.setInterval(function(){if(!doc.hidden)schedule();},15000);
    schedule();
  }
  return {matches:matches,decisionKey:decisionKey,declined:declined,validate:validate,bundleKey:bundleKey,purchaseFacts:purchaseFacts,purchaseSubtotal:purchaseSubtotal,nextOperation:nextOperation,createController:createController,mount:mount};
});
